import { all, call, getContext, put, takeEvery } from "redux-saga/effects";
import { CONTEXT } from "@const/redux";

import { setAuthors } from "../authors/actions";
import {
  getNotificationCountFailure,
  getNotificationCountSuccess,
  getNotificationFailure,
  getNotificationPortionFailure,
  getNotificationPortionSuccess,
  getNotificationSuccess,
  hideNotificationFailure,
  hideNotificationSuccess,
  newNotificationReceivedSuccess,
  readNotifications,
  readNotificationsFailure,
  readNotificationsSuccess,
} from "./actions";
import {
  getNotificationActionType,
  getNotificationCountActionType,
  getPortionNotificationActionType,
  hideNotificationActionType,
  newNotificationReceivedActionTypes,
  readNotificationsActionType,
} from "./actionTypes";
import { normalizeNotificationArray } from "@helpers/notifications";

const getNotificationsAsync = ({ NotificationsService, params }) => {
  if (!NotificationsService) {
    console.log("Required services does not exist");

    return;
  }

  return NotificationsService.getNotifications(params);
};

function* getNotifications({ payload }) {
  try {
    const { NotificationsService } = yield getContext(CONTEXT.SERVICES);
    const { data, pagination } = yield call(getNotificationsAsync, {
      NotificationsService,
      params: payload,
    });

    const { entities, result: allNotifications } =
      normalizeNotificationArray(data);

    const { emitter, notifications: notificationsById } = entities;
    const { totalCount } = pagination;

    yield all([
      put(
        getNotificationSuccess({
          allNotifications,
          notificationsById,
          totalCount,
        }),
      ),
      put(readNotifications()),
      put(setAuthors(emitter)),
    ]);
  } catch ({ error }) {
    yield put(getNotificationFailure(error));
  }
}

function* getNotificationsPortion({ payload }) {
  try {
    const { NotificationsService } = yield getContext(CONTEXT.SERVICES);
    const { data, pagination } = yield call(getNotificationsAsync, {
      NotificationsService,
      params: payload,
    });

    const { entities, result: allNotifications } =
      normalizeNotificationArray(data);
    const { emitter, notifications: notificationsById } = entities;
    const { totalCount } = pagination;

    yield all([
      put(
        getNotificationPortionSuccess({
          allNotifications,
          notificationsById,
          totalCount,
        }),
      ),
      put(setAuthors(emitter)),
    ]);
  } catch ({ error }) {
    yield put(getNotificationPortionFailure(error));
  }
}

const getNotificationsCountAsync = ({ NotificationsService }) => {
  if (!NotificationsService) {
    console.log("Required services does not exist");

    return;
  }

  return NotificationsService.getNotificationsCount();
};

function* getNotificationsCount() {
  try {
    const { NotificationsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(getNotificationsCountAsync, {
      NotificationsService,
    });

    yield put(getNotificationCountSuccess(data));
  } catch ({ error }) {
    yield put(getNotificationCountFailure(error));
  }
}

const hideNotificationAsync = ({ NotificationsService, id }) => {
  if (!NotificationsService) {
    console.log("Required services does not exist");

    return;
  }

  return NotificationsService.hideNotification(id);
};

function* hideNotification({ payload: id }) {
  try {
    const { NotificationsService } = yield getContext(CONTEXT.SERVICES);
    yield call(hideNotificationAsync, {
      NotificationsService,
      id,
    });

    yield put(hideNotificationSuccess(id));
  } catch ({ error }) {
    yield put(hideNotificationFailure(error));
  }
}

const readNotificationsAsync = ({ NotificationsService }) => {
  if (!NotificationsService) {
    console.log("Required services does not exist");

    return;
  }

  return NotificationsService.readNotifications();
};

export function* newNotificationReceived({ payload }) {
  try {
    const { data } = payload;
    const { entities, result: allNotifications } = normalizeNotificationArray([
      data,
    ]);

    const { emitter, notifications: notificationsById } = entities;

    yield all([
      put(
        newNotificationReceivedSuccess({
          allNotifications,
          notificationsById,
        }),
      ),
      put(setAuthors(emitter)),
    ]);
  } catch (error) {
    console.error(error);
  }
}

function* readNotifications1() {
  try {
    const { NotificationsService } = yield getContext(CONTEXT.SERVICES);
    yield call(readNotificationsAsync, {
      NotificationsService,
    });

    yield put(readNotificationsSuccess());
  } catch ({ error }) {
    yield put(readNotificationsFailure(error));
  }
}

export function* watchGetNotifications() {
  yield takeEvery(getNotificationActionType.request, getNotifications);
}

export function* watchGetNotificationsPortion() {
  yield takeEvery(
    getPortionNotificationActionType.request,
    getNotificationsPortion,
  );
}

export function* watchGetNotificationsCount() {
  yield takeEvery(
    getNotificationCountActionType.request,
    getNotificationsCount,
  );
}

export function* watchHideNotifications() {
  yield takeEvery(hideNotificationActionType.request, hideNotification);
}

export function* watchReadNotifications() {
  yield takeEvery(readNotificationsActionType.request, readNotifications1);
}

export function* watchNewNotificationReceived() {
  yield takeEvery(
    newNotificationReceivedActionTypes.request,
    newNotificationReceived,
  );
}
